/**
 * Single source of truth for all pre-rendered static routes and their metadata.
 *
 * Used by:
 *   - src/index.js              (hydration vs. client-render decision)
 *   - scripts/updateReactSnapRoutes.mjs  (writes reactSnap.include to package.json)
 *   - scripts/injectMetadata.mjs         (injects <title>, <meta>, canonical, sitemap)
 *
 * To add a new static route:
 *   1. Add an entry here with its title and description.
 *   2. That's it — the build pipeline picks it up automatically.
 */

export const staticRoutesMetadata = {
  '/': {
    title: 'Medical Records Review AI',
    description: 'Cut medical records review time by 90% with detailed, deduped, indexed chronologies, tabulated expenses, drafting, and automatic flagging of concerns.'
  },
  '/about': {
    title: 'About Us - AttorneyAide.com',
    description: 'Built by legal experts. Powered by Seattle innovation. Our mission to empower legal teams with accurate, affordable, and instantly accessible AI-powered tools.'
  },
  '/contact': {
    title: 'Contact Us - AttorneyAide.com',
    description: 'Have a question or feedback? We\'d love to hear from you. Fill out the form below and we\'ll get back to you as soon as possible.'
  },
  '/pricing': {
    title: 'Pricing - AttorneyAide.com',
    description: 'Transparent pricing for AttorneyAide. No contracts, no friction. Choose Basic, Professional, or Enterprise—month-to-month plans with credits for medical record processing.'
  },
  '/press': {
    title: 'Press - AttorneyAide.com',
    description: 'Press releases and news about AttorneyAide.com. AI Assistant cuts medical records review time by 90% with detailed, deduped, indexed chronologies, tabulated expenses, drafting, and automatic flagging of concerns.'
  },
  '/privacy': {
    title: 'Privacy Policy - AttorneyAide.com',
    description: 'Privacy policy for AttorneyAide.com. We are committed to protecting your privacy and security.'
  },
  '/security': {
    title: 'Privacy and Security - AttorneyAide.com',
    description: 'HIPAA-grade security and zero-training privacy. Our platform is designed ground up for law professionals with end-to-end encryption and verifiable accuracy.'
  },
  '/terms': {
    title: 'Terms of Service - AttorneyAide.com',
    description: 'Terms of service for AttorneyAide.com. We are committed to providing a fair and transparent service to our users.'
  }
};

